import React, { useState } from "react";
import "./faq.css";

const faqData = [
  {
    category: "About PrrepX Pathshala",
    items: [
      {
        question: "What makes PrrepX Pathshala different from other platforms?",
        answer:
          "PrrepX Pathshala is India's only platform where 100% of the faculty are verified IIT/NIT alumni and top Medical graduates. We combine elite-level expertise with a mission of 'Education for All,' offering a complete learning ecosystem from Class 6 foundations to JEE/NEET mastery — at the most affordable rates in the country.",
      },
      {
        question: "Who are the teachers at PrrepX Pathshala?",
        answer:
          "Every teacher at PrrepX Pathshala is a verified alumnus of an IIT, NIT, or a top-tier Medical college. By learning from those who have actually cracked these exams, you gain deep conceptual clarity, proven strategies, and the right mindset for a top rank.",
      },
      {
        question: "Is PrrepX Pathshala only for JEE/NEET students?",
        answer:
          "No! We serve students from Class 6 all the way through Class 12, along with dedicated tracks for IIT-JEE, NEET, and other competitive exams. Whether you are building foundations or targeting a top rank, there is a complete path for you on the platform.",
      },
      {
        question: "Can financially weaker students benefit from PrrepX Pathshala?",
        answer:
          "Absolutely. Our vision is that no dream should fade due to lack of money. We provide full-fledged lectures, comprehensive practice sets, and mock tests completely free — meticulously designed by our IITian core team so that a student with zero financial backing can compete at the highest level.",
      },
      {
        question: "What is the ultimate vision of PrrepX Pathshala?",
        answer:
          "Our vision is to bridge the gap between elite education and mass accessibility. By providing 100% top-alumni faculty at the least cost in the country, we are building a future where quality education is a right — ensuring every hardworking student in India gets a fair shot at success.",
      },
    ],
  },
  {
    category: "Courses & Curriculum",
    items: [
      {
        question: "What classes and streams are covered on PrrepX Pathshala?",
        answer:
          "We cover Class 6 to Class 12 (Science and Maths), IIT-JEE (Main and Advanced), and NEET. The content is organized subject-wise and chapter-wise for easy navigation, following the NCERT curriculum and extending into high-level competitive exam topics.",
      },
      {
        question: "Is the lecture content free or paid?",
        answer:
          "The vast majority of our lecture content — video lectures, notes, and practice sheets — is completely free. Premium test series are available at a very affordable price, but core learning material remains accessible to all students without any payment.",
      },
      {
        question: "How is the lecture content organized?",
        answer:
          "Lectures are organized by stream (JEE, NEET, Class 11/12, Class 6-10), then by subject (Physics, Chemistry, Mathematics, Biology), and finally chapter-wise within each subject. This structured approach lets you move linearly through a syllabus or jump to any specific topic.",
      },
      {
        question: "Are study materials and written notes available?",
        answer:
          "Yes. Downloadable PDFs, formula sheets, short notes, and previous year question (PYQ) compilations are available for most subjects. These are prepared by our IIT/Medical faculty to complement the video lectures.",
      },
      {
        question: "How often is new content added?",
        answer:
          "New lectures, practice sheets, and test series are added regularly as our faculty team keeps pace with syllabus updates and exam pattern changes. You can check the latest additions from the homepage or subject-specific pages.",
      },
    ],
  },
  {
    category: "Mentorship & Doubts",
    items: [
      {
        question: "How does the 24/7 doubt resolution system work?",
        answer:
          "You can submit any academic doubt through our Doubt Portal, categorized by subject and topic. Our team of IIT/Medical alumni reviewers responds with detailed solutions. Most doubts are resolved within a few hours, often faster during daytime hours.",
      },
      {
        question: "Can I get 1-on-1 mentorship?",
        answer:
          "Yes. Personal mentorship by IIT/NIT alumni is available for students who need extra guidance on strategy, subject selection, or weak-area improvement. You can request a mentorship session through the contact page.",
      },
      {
        question: "What is Confidential Support?",
        answer:
          "Confidential Support is our private, one-on-one messaging channel with our team — designed for students who need to talk about personal challenges, exam stress, or mental health concerns. All conversations are completely private and non-judgmental.",
      },
      {
        question: "How quickly are doubts answered?",
        answer:
          "Most academic doubts are answered within 2-6 hours. During peak hours and exam season, response times may vary slightly but we aim to never leave a doubt unanswered for more than 24 hours.",
      },
      {
        question: "Is mentorship free?",
        answer:
          "General doubt resolution is free for all students. One-on-one personal mentorship sessions may have a nominal fee depending on the depth and duration of guidance required. Basic career and strategy advice is always free.",
      },
    ],
  },
  {
    category: "Career Guidance",
    items: [
      {
        question: "What career guidance services does PrrepX Pathshala offer?",
        answer:
          "We offer comprehensive after-Class-12 guidance covering higher education options, stream selection, college shortlisting, entrance exam roadmaps, and career path exploration. Our IITian mentors guide you through every step.",
      },
      {
        question: "Does PrrepX Pathshala provide guidance after Class 12?",
        answer:
          "Yes! Our 'After Class 12' section covers a wide range of career paths including Engineering, Medicine, Law, Commerce, Arts, Defence, and more — with detailed roadmaps, exam timelines, and college lists to help you make an informed decision.",
      },
      {
        question: "How can I explore different career options on the platform?",
        answer:
          "Visit the 'Career Guidance' or 'After Class 12' page from the main navigation. Each career path has a detailed overview, required entrance exams, top colleges, and tips from alumni who have pursued that path.",
      },
      {
        question: "Are there internship or job assistance programs?",
        answer:
          "We are building partnerships with companies and research institutes to provide internship and project opportunities for top-performing students. This feature is currently in early access — stay tuned for more updates.",
      },
    ],
  },
  {
    category: "Account & Access",
    items: [
      {
        question: "How do I create an account?",
        answer:
          "Click 'Sign In' on the top navigation bar and log in with your Google account. No separate registration is required — signing in with Google automatically creates your PrrepX Pathshala profile.",
      },
      {
        question: "Can I use my account on multiple devices?",
        answer:
          "Yes. Your account is linked to your Google login, so you can access it from any device — phone, tablet, or computer — without any additional setup. Your purchased content and progress sync automatically.",
      },
      {
        question: "How do I update my profile information?",
        answer:
          "Go to your Profile page (accessible from the top navigation after signing in). You can update your name, class, exam target, mobile number, profile photo, and other details directly from there.",
      },
      {
        question: "What do I do if I forgot my password?",
        answer:
          "Since we use Google Sign-In, there is no separate PrrepX Pathshala password. If you have forgotten your Google account password, please use Google's 'Forgot Password' recovery flow at accounts.google.com.",
      },
      {
        question: "How do I delete my account?",
        answer:
          "To request account deletion, contact our support team through the Confidential Support page or email us directly. We will process your request and remove all your data within 7 business days as per our privacy policy.",
      },
    ],
  },
];
{/*
  {
    category: "Test Series",
    items: [
      {
        question: "What types of test series are available?",
        answer:
          "We offer 12 categories of Premium Test Series and 3 categories of Free Test Series — covering JEE Main, JEE Advanced, NEET, Chapter-wise tests, Full Syllabus Mocks, and Previous Year Question (PYQ) tests. Each set is crafted by our IIT/Medical experts to mirror actual exam difficulty.",
      },
      {
        question: "Are there free test series available?",
        answer:
          "Yes! We have free PYQ-based test series available without any login or payment. These allow every student, regardless of financial background, to test their skills with real exam-level questions.",
      },
      {
        question: "How do I access the premium test series?",
        answer:
          "Visit our Test Series portal at testseries.prrepxpathshala.live, sign in with your Google account, and purchase the desired series via Razorpay. Once purchased, the series is permanently accessible from your account's 'My Tests' section.",
      },
      {
        question: "What subjects are covered in the test series?",
        answer:
          "Premium test series cover Physics, Chemistry, Mathematics (for JEE), and Physics, Chemistry, Biology (for NEET). Chapter-wise and full-length tests are available for all these subjects at both Class 11 and Class 12 levels.",
      },
      {
        question: "Can I retake a test after submitting?",
        answer:
          "Yes, you can retake purchased tests multiple times. After each attempt, you can review the detailed solution with correct answers and explanations, helping you identify weak areas and improve over time.",
      },
    ],
  },
  {
    category: "Fees & Payments",
    items: [
      {
        question: "How do I purchase a premium test series?",
        answer:
          "Go to the Test Series portal, select the test series you want, click 'Buy Now,' and complete the payment via Razorpay. UPI, net banking, credit/debit cards, and wallets are all supported. Your purchase is linked to your Google account instantly.",
      },
      {
        question: "What payment methods are accepted?",
        answer:
          "We accept all major payment modes: UPI (Google Pay, PhonePe, Paytm), Net Banking (all major banks), Credit Cards, Debit Cards, and popular wallets. Payments are processed securely through Razorpay.",
      },
      {
        question: "Can I pay from outside India?",
        answer:
          "Currently, our payment gateway primarily supports Indian payment methods. If you are based outside India, please reach out to our support team and we will try to assist you with alternative arrangements.",
      },
      {
        question: "Can I get a refund if I am not satisfied?",
        answer:
          "Refund requests can be raised within 7 days of purchase if you have not attempted the test. To request a refund, contact our support team with your order ID. Refunds are processed within 5-7 business days.",
      },
      {
        question: "What if I face a payment issue?",
        answer:
          "If your payment is deducted but access is not granted, please wait 24 hours as it may be a sync delay. If the issue persists, contact us with your transaction ID and we will resolve it manually on priority.",
      },
    ],
  },
  {
    category: "Technical Support",
    items: [
      {
        question: "I cannot access my purchased content. What should I do?",
        answer:
          "First, try logging out and logging back in with the same Google account you used for purchase. If the problem persists, clear your browser cache and try again. For unresolved issues, contact our support team with your registered email and order ID.",
      },
      {
        question: "The platform is not loading properly. How do I fix it?",
        answer:
          "Try a hard refresh (Ctrl + Shift + R), clear browser cookies and cache, or try a different browser. Our platform works best on the latest versions of Chrome, Firefox, and Edge. If videos are not loading, check your internet connection speed.",
      },
      {
        question: "Is the platform available on mobile?",
        answer:
          "Yes! PrrepX Pathshala is fully mobile-responsive and works on any modern smartphone browser. We also have an Android app for a native experience. Simply search 'PrrepX Pathshala' on the Play Store or use the APK from our website.",
      },
      {
        question: "How do I report a bug or technical issue?",
        answer:
          "Use the Confidential Support or Contact page on our website, or email us directly. Please include details like your device, browser, and screenshots of the issue. Our team responds within 24 hours.",
      },
      {
        question: "What browsers are supported?",
        answer:
          "We support all modern browsers: Google Chrome (recommended), Mozilla Firefox, Microsoft Edge, and Safari. For the best experience, ensure your browser is updated to the latest version. Internet Explorer is not supported.",
      },
    ],
  },
  */}
export default function PrrepXPathshalaFAQ() {
  const [activeCategory, setActiveCategory] = useState(0);
  const [openIndex, setOpenIndex] = useState(null);

  const handleCategoryChange = (idx) => {
    setActiveCategory(idx);
    setOpenIndex(null);
  };

  const toggleItem = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const currentItems = faqData[activeCategory].items;

  return (
    <section className="faq2-section">
      <div className="faq2-header">
        <h2 className="faq2-title">Frequently Asked Questions</h2>
        <p className="faq2-subtitle">Everything you need to know about PrrepX Pathshala</p>
      </div>

      <div className="faq2-body">
        <aside className="faq2-sidebar">
          {faqData.map((cat, idx) => (
            <button
              key={idx}
              className={"faq2-cat-btn" + (activeCategory === idx ? " active" : "")}
              onClick={() => handleCategoryChange(idx)}
            >
              {cat.category}
            </button>
          ))}
        </aside>

        <div className="faq2-panel">
          {currentItems.map((item, idx) => (
            <div
              key={idx}
              className={"faq2-item" + (openIndex === idx ? " open" : "")}
            >
              <button
                className="faq2-question"
                onClick={() => toggleItem(idx)}
                aria-expanded={openIndex === idx}
              >
                <span>{item.question}</span>
                <span className="faq2-chevron">{openIndex === idx ? "^" : "v"}</span>
              </button>
              {openIndex === idx && (
                <div className="faq2-answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
